import { styled } from '@mui/system'

export const OpenIssuesPageWrapper = styled('div')`
    .dashboard-page.fraud-defense-open-issues {
        .page-content {
            padding-bottom: 56px;
        }
    }
`

export const InfoBannerWrapper = styled('div')`
    margin-top: 24px;
`

export const ErrorMessageWrapper = styled('div')`
    padding: 20px;
    color: red;
`

export const LoadingMessageWrapper = styled('div')`
    padding: 20px;
`
